import { COMANAGER_HEIGHT, enumAlignStyle, enumBranchStyle } from "../constants";
import { NodePoly } from "./NodePoly";

export class LineConnector {
  constructor() {
    this.fInvertedChart = false;
  }

  SetInvertedChart(inverted) {
    this.fInvertedChart = inverted;
  }

  // Adds connecting line from entity to its children
  AddConnectingLines(entity) {
    // first let the children do the same
    if (entity) {
      var children = entity.GetChildren();
      for (var i = 0; i < children.length; i++) {
        var child = children[i];
        var lineConnector = new LineConnector();
        lineConnector.SetInvertedChart(this.fInvertedChart);
        lineConnector.AddConnectingLines(child);
      }
    }

    if (!entity || !entity.fNode) {
      return;
    }

    entity.fNode.ClearLines();

    var connectingPoint = entity.BottomConnectorPoint();

    // first go with peer assistants.
    this.AddLinesPeers(entity);

    // then add assistant lines
    var leftAssistants =
      entity.NumChildren("AssistantLeft") > 0 ? entity.fDescendents["AssistantLeft"] : [];
    var rightAssistants =
      entity.NumChildren("AssistantRight") > 0 ? entity.fDescendents["AssistantRight"] : [];
    var numAssistants = leftAssistants.length + rightAssistants.length;
    var subs = entity.NumChildren("Subordinate") > 0 ? entity.fDescendents["Subordinate"] : [];
    connectingPoint = this.AddLinesTwoColumn(
      entity,
      leftAssistants,
      rightAssistants,
      subs,
      connectingPoint
    );

    // now subordinates
    var nSubs = entity.NumChildren("Subordinate");
    if (nSubs > 0) {
      var alignPoints = [];
      var branchStyle = entity.fSubBranchStyle;
      var firstSub = entity.GetEntity("Subordinate", 0);
      var spacing = entity.GetMgrVSpacings();

      switch (branchStyle) {
        case enumBranchStyle.tree:
        case enumBranchStyle.stagger:
          this.AddLinesTreeStyle(entity, subs, connectingPoint, false);
          break;

        case enumBranchStyle.banded:
          this.AddLinesBandedStyle(entity, subs, connectingPoint);
          break;
        case enumBranchStyle.twocolumn:
        case enumBranchStyle.fourcolumn:
        case enumBranchStyle.sixcolumn:
        case enumBranchStyle.eightcolumn:
        case enumBranchStyle.twelvecolumn:
        case enumBranchStyle.sixteencolumn:
        case enumBranchStyle.twentycolumn:
          var alignPoint = {
            x: entity.BottomConnectorPoint().x,
            y: connectingPoint.y
          };
          this.AddLinesMultiColumn(entity, alignPoint);
          break;

        case enumBranchStyle.onecolumnright:
          alignPoint = {
            x: entity.BottomConnectorPoint().x,
            y: connectingPoint.y
          };
          alignPoints.push(alignPoint);
          this.AddLinesOneColumn(entity, alignPoints, enumAlignStyle.left);
          break;

        case enumBranchStyle.onecolumnleft:
          alignPoint = {
            x: entity.BottomConnectorPoint().x,
            y: connectingPoint.y
          };
          alignPoints.push(alignPoint);
          this.AddLinesOneColumn(entity, alignPoints, enumAlignStyle.right);
          break;

        case enumBranchStyle.onecolumncenterright:
          alignPoints.push({ x: connectingPoint.x, y: connectingPoint.y });
          connectingPoint.y = firstSub.fNodePoly.fEnvelope.fTop - spacing.lowerSpacing;
          alignPoints.push({ x: connectingPoint.x, y: connectingPoint.y });
          if (numAssistants === 0) {
            connectingPoint.x = entity.fBox.fLeft;
          }
          alignPoints.push(connectingPoint);
          this.AddLinesOneColumn(entity, alignPoints, enumAlignStyle.left);
          break;

        case enumBranchStyle.onecolumncenterleft:
          alignPoints.push({ x: connectingPoint.x, y: connectingPoint.y });
          connectingPoint.y = firstSub.fNodePoly.fEnvelope.fTop - spacing.lowerSpacing;
          alignPoints.push({ x: connectingPoint.x, y: connectingPoint.y });
          if (numAssistants === 0) {
            connectingPoint.x = entity.fBox.fRight;
          }
          alignPoints.push(connectingPoint);
          this.AddLinesOneColumn(entity, alignPoints, enumAlignStyle.right);
          break;

        default:
          break;
      }
    }

    this.AddMultipleBottomLines(entity, connectingPoint);
  }

  AddMultipleBottomLines(entity) {
    if (!entity || !entity.HasMultipleBottomLines()) {
      //TODO: check for assistants and peers.
      return;
    }

    if (!entity.BottomConnectingLineExists()) {
      return;
    }

    // conditions not to draw multiple bottom lines
    var bottomLinesCount = entity.fAnchorDown.length;
    var subs = entity.GetEntities("Subordinate");

    var centerPoint = entity.BottomConnectorPoint();

    // vertical lines from each entity to the bottom cross line
    var insideSubs = entity.GetEntities("InsideChild");

    // need to break points into three groups: left, middle and right
    var leftXs = [];
    var rightXs = [];
    for (var i = 0; i < bottomLinesCount; i++) {
      var x = entity.fAnchorDown[i].x;
      if (x < centerPoint.x) {
        leftXs.push(x);
      } else if (x > centerPoint.x) {
        rightXs.push(x);
      }

      var pointTop = { x: x, y: entity.fAnchorDown[i].y };
      var pointBottom = { x: x, y: centerPoint.y };
      this.AddLineAndAssociate(entity, pointTop, pointBottom, subs);
      //TODO: assign to all insideSubs maybe?
    }

    // now the horizontal line
    var pointRight = centerPoint;
    leftXs.reverse();
    while (leftXs.length > 0) {
      var pointLeft = { x: leftXs[0], y: centerPoint.y };
      this.AddLineAndAssociate(entity, pointLeft, pointRight, subs);
      pointRight = pointLeft;
      leftXs.shift();
    }

    pointLeft = centerPoint;
    while (rightXs.length > 0) {
      pointRight = { x: rightXs[0], y: centerPoint.y };
      this.AddLineAndAssociate(entity, pointLeft, pointRight, subs);
      pointLeft = pointRight;
      rightXs.shift();
    }

    return centerPoint;
  }

  AddLinesPeers(entity) {
    if (!entity) return;

    //TODO: Update code for peers
    if (entity.NumChildren("PeerLeft") === 1) {
      var peer = entity.GetEntity("PeerLeft", 0);
      if (peer.fBox.fTop === entity.fBox.fTop) {
        var y = Math.min(entity.Center().y, peer.Center().y);
        var startPoint = { x: peer.fBox.fRight, y: y };
        var endPoint = { x: entity.fBox.fLeft, y: y };
        this.AddLineAndAssociate(entity, startPoint, endPoint, peer);
      } else {
        var p1 = [];
        var p2 = [];
        p1.push({ x: peer.fBox.fRight, y: peer.Center().y });
        p1.push({
          x: Math.round((peer.fBox.fRight + entity.fBox.fLeft) / 2),
          y: peer.Center().y
        });
        p1.push({
          x: Math.round((peer.fBox.fRight + entity.fBox.fLeft) / 2),
          y: entity.Center().y
        });
        p2.push(p1[1]);
        p2.push(p1[2]);
        p2.push({ x: entity.fBox.fLeft, y: entity.Center().y });
        for (var i = 0; i < p1.length; i++) {
          this.AddLineAndAssociate(entity, p1[i], p2[i], peer);
        }
      }
    }

    if (entity.NumChildren("PeerRight") === 1) {
      peer = entity.GetEntity("PeerRight", 0);
      if (peer.fBox.fTop === entity.fBox.fTop) {
        y = Math.min(entity.Center().y, peer.Center().y);
        startPoint = { x: entity.fBox.fRight, y: y };
        endPoint = { x: peer.fBox.fLeft, y: y };
        this.AddLineAndAssociate(entity, startPoint, endPoint, peer);
      } else {
        p1 = [];
        p2 = [];
        p1.push({ x: entity.fBox.fRight, y: entity.Center().y });
        p1.push({
          x: Math.round((entity.fBox.fRight + peer.fBox.fLeft) / 2),
          y: entity.Center().y
        });
        p1.push({
          x: Math.round((entity.fBox.fRight + peer.fBox.fLeft) / 2),
          y: peer.Center().y
        });
        p2.push(p1[1]);
        p2.push(p1[2]);
        p2.push({ x: peer.fBox.fLeft, y: peer.Center().y });
        for (i = 0; i < p1.length; i++) {
          this.AddLineAndAssociate(entity, p1[i], p2[i], peer);
        }
      }
    }
  }

  /**
   * @return {number}
   */
  AddLinesTreeStyle(entity, subs, startPoint, ignoreManagerSpacing) {
    if (!entity) {
      return 0;
    }

    // adding lines for children that are aligned tree-stylishly
    var n = subs.length;
    if (n === 0) {
      return 0;
    }

    var comanagerSpace = entity.ComanagerExists(subs) ? COMANAGER_HEIGHT : 0;
    var topLineY = subs[0].fNodePoly.fEnvelope.fTop - comanagerSpace;

    if (!ignoreManagerSpacing) {
      var spacing = entity.GetMgrVSpacings();
      topLineY = topLineY - spacing.lowerSpacing;
    } else {
      topLineY = topLineY - 6;
    }

    // first let's draw vertical line from entity to top of cross bar for subordinates
    var point2 = { x: startPoint.x, y: topLineY };
    this.AddLineAndAssociate(entity, startPoint, point2, subs);

    // need to break subs into three groups: left, middle and right
    var leftSubs = [];
    var rightSubs = [];

    // breaking the subs into three categories
    for (var i = 0; i < subs.length; i++) {
      var x = subs[i].TopConnectorPoint().x;
      if (x < startPoint.x) {
        leftSubs.push(subs[i]);
      } else if (x > startPoint.x) {
        rightSubs.push(subs[i]);
      }

      var pointTop = { x: x, y: topLineY };

      if (subs[i].HasMultipleTopLines()) {
        this.AddTopLines(entity, subs[i], pointTop);
      } else {
        var pointBottom = { x: subs[i].fAnchorUp.x, y: subs[i].fAnchorUp.y };
        this.AddLineAndAssociate(entity, pointTop, pointBottom, subs[i]);
      }
    }

    var pointRight = { x: startPoint.x, y: topLineY };
    leftSubs.reverse();
    while (leftSubs.length > 0) {
      var pointLeft = { x: leftSubs[0].TopConnectorPoint().x, y: topLineY };
      this.AddLineAndAssociate(entity, pointLeft, pointRight, leftSubs);
      pointRight = pointLeft;
      leftSubs.shift();
    }

    pointLeft = { x: startPoint.x, y: topLineY };
    while (rightSubs.length > 0) {
      pointRight = { x: rightSubs[0].TopConnectorPoint().x, y: topLineY };
      this.AddLineAndAssociate(entity, pointLeft, pointRight, rightSubs);
      pointLeft = pointRight;
      rightSubs.shift();
    }

    return topLineY;
  }

  /**
   * @return {number}
   */
  AddTopLines(entity, subContainer, startPoint, topLineY) {
    var insideSubs = subContainer.GetEntities("InsideChild");
    if (typeof topLineY === "undefined") {
      topLineY = subContainer.fNodePoly.fEnvelope.fTop;
      var spacing = entity.GetMgrVSpacings();
      topLineY -= spacing.lowerSpacing;
    }

    if (insideSubs.length === 0) {
      return topLineY;
    }

    // first let's draw vertical line from startPoint to top of cross bar for subordinates
    var point2 = { x: startPoint.x, y: topLineY };
    this.AddLineAndAssociate(entity, startPoint, point2, insideSubs);

    // need to break points into three groups: left, middle and right
    var leftXs = [];
    var rightXs = [];
    for (var i = 0; i < subContainer.NumTopConnectors(); i++) {
      var x = subContainer.fAnchorUp[i].x;
      if (x < startPoint.x) {
        leftXs.push(x);
      } else if (x > startPoint.x) {
        rightXs.push(x);
      }

      var pointTop = { x: x, y: topLineY };
      var pointBottom = { x: x, y: subContainer.fAnchorUp[i].y };
      this.AddLineAndAssociate(entity, pointTop, pointBottom, insideSubs);
    }

    // now the horizontal line
    var pointRight = { x: startPoint.x, y: topLineY };
    leftXs.reverse();
    while (leftXs.length > 0) {
      var pointLeft = { x: leftXs[0], y: topLineY };
      this.AddLineAndAssociate(entity, pointLeft, pointRight, insideSubs);
      pointRight = pointLeft;
      leftXs.shift();
    }

    pointLeft = { x: startPoint.x, y: topLineY };
    while (rightXs.length > 0) {
      pointRight = { x: rightXs[0], y: topLineY };
      this.AddLineAndAssociate(entity, pointLeft, pointRight, insideSubs);
      pointLeft = pointRight;
      rightXs.shift();
    }

    return topLineY;
  }

  // entity is parent entity. subContainer has multiple entities inside and they
  // need multiple lines on top to draw to the parent.
  // For now, the connecting is to the inside children in each column.
  AddLinesBandedStyle(entity, subs, startPoint) {
    // need to go over all bands and repeatedly call tree style
    var bandStartPoint = startPoint;
    var bandedSubs = entity.GetBandedSubs(subs);
    for (var i = 0; i < bandedSubs.length; i++) {
      bandStartPoint.y = this.AddLinesTreeStyle(entity, bandedSubs[i], bandStartPoint, i > 0);
    }
  }

  AddLinesAssistantComanagers(parentEntity, entity, connectingPoint) {
    var insideSubs = entity.GetEntities("InsideChild");
    if (insideSubs.length === 0 || !entity.HasMultipleTopLines()) {
      return;
    }

    var topPoint = { x: entity.TopAnchorPoint().x, y: connectingPoint.y };
    this.AddTopLines(parentEntity, entity, topPoint, connectingPoint.y + COMANAGER_HEIGHT);
    this.AddLineAndAssociate(parentEntity, topPoint, connectingPoint, entity);
  }

  AddLinesOneColumn(entity, alignPoints, alignType) {
    if (!entity) {
      return;
    }

    // adding lines for children that are aligned tree-stylishly
    if (entity.NumChildren("Subordinate") === 0) {
      return;
    }

    // if more than one align point exists, this is a sign of that wiggly thingy
    var numAlignPoints = alignPoints.length;
    if (numAlignPoints === 3) {
      var alignPoint1 = alignPoints[0];
      var alignPoint2 = alignPoints[1];
      this.AddLineAndAssociate(
        entity,
        alignPoint1,
        alignPoint2,
        entity.fDescendents["Subordinate"]
      );

      if (alignPoints[2].x > alignPoints[1].x) {
        alignPoint1 = alignPoints[1];
        alignPoint2 = alignPoints[2];
      } else {
        alignPoint1 = alignPoints[2];
        alignPoint2 = alignPoints[1];
      }
      this.AddLineAndAssociate(
        entity,
        alignPoint1,
        alignPoint2,
        entity.fDescendents["Subordinate"]
      );
    }

    var alignPoint = alignPoints[numAlignPoints - 1];
    var subs = entity.fDescendents["Subordinate"].slice(0);
    var startPoint = { x: alignPoint.x, y: alignPoint.y };
    while (subs.length > 0) {
      var sub = subs[0];
      var endPoint = { x: alignPoint.x, y: sub.Center().y };
      this.AddLineAndAssociate(entity, startPoint, endPoint, subs);
      startPoint.y = endPoint.y;
      subs.shift();
    }

    // now horizontal connectors to each entity
    subs = entity.fDescendents["Subordinate"].slice(0);
    while (subs.length > 0) {
      sub = subs.shift();
      switch (alignType) {
        case enumAlignStyle.left:
          startPoint = { x: alignPoint.x, y: sub.AnchorLeft().y };
          endPoint = { x: sub.AnchorLeft().x, y: sub.AnchorLeft().y };
          break;

        case enumAlignStyle.right:
          startPoint = { x: sub.AnchorRight().x, y: sub.AnchorRight().y };
          endPoint = { x: alignPoint.x, y: sub.AnchorRight().y };
          break;

        default:
          break;
      }
      this.AddLineAndAssociate(entity, startPoint, endPoint, sub);
    }
  }

  AddLinesTwoColumn(entity, leftEntities, rightEntities, additionalEntities, alignPoint) {
    // it adds connecting lines for two first entities lists (left and right). It also associates th
    // entities in the additional entities with these lines.
    var lefts = leftEntities ? leftEntities.slice(0) : [];
    var rights = rightEntities ? rightEntities.slice(0) : [];
    if (lefts.length === 0 && rights.length === 0) {
      return alignPoint;
    }

    var point1 = { x: alignPoint.x, y: alignPoint.y };
    var yLeft, yRight;
    var result = this.DetermineTwoColumnYs(lefts, rights);
    yLeft = result.left;
    yRight = result.right;

    while (lefts.length > 0 || rights.length > 0) {
      var subs = additionalEntities ? additionalEntities : [];
      subs = subs.concat(lefts, rights);
      if (yLeft < yRight) {
        // horizontal line to left entity
        var startPoint = { x: lefts[0].fBox.fRight, y: yLeft };
        var endPoint = { x: alignPoint.x, y: yLeft };
        var point2 = { x: alignPoint.x, y: yLeft };
        this.AddLineAndAssociate(entity, startPoint, endPoint, lefts[0]);
        this.AddLinesAssistantComanagers(entity, lefts[0], startPoint);
        lefts.shift();
        yLeft = lefts.length ? lefts[0].AnchorLeft().y : Number.POSITIVE_INFINITY;
      } else if (yRight < yLeft) {
        startPoint = { x: alignPoint.x, y: yRight };
        endPoint = { x: rights[0].fBox.fLeft, y: yRight };
        point2 = { x: alignPoint.x, y: yRight };
        this.AddLineAndAssociate(entity, startPoint, endPoint, rights[0]);
        this.AddLinesAssistantComanagers(entity, rights[0], startPoint);
        rights.shift();
      } // this is for case both are equal
      else {
        // left side
        startPoint = { x: lefts[0].fBox.fRight, y: yLeft };
        endPoint = { x: alignPoint.x, y: yLeft };
        point2 = { x: alignPoint.x, y: yLeft };
        this.AddLineAndAssociate(entity, startPoint, endPoint, lefts[0]);
        this.AddLinesAssistantComanagers(entity, lefts[0], startPoint);
        lefts.shift();

        // right side
        startPoint = { x: alignPoint.x, y: yRight };
        endPoint = { x: rights[0].fBox.fLeft, y: yRight };
        this.AddLineAndAssociate(entity, startPoint, endPoint, rights[0]);
        this.AddLinesAssistantComanagers(entity, rights[0], startPoint);
        rights.shift();
      }

      result = this.DetermineTwoColumnYs(lefts, rights);
      yLeft = result.left;
      yRight = result.right;
      // do the vertical line
      this.AddLineAndAssociate(entity, point1, point2, subs);
      point1 = { x: point2.x, y: point2.y };
    }

    return { x: point2.x, y: point2.y };
  }

  AddLinesMultiColumn(entity, alignPoint) {
    if (!entity) {
      return;
    }

    var nSubs = entity.NumChildren("Subordinate");
    if (nSubs === 0) {
      return;
    }

    // handle the case of one sub which is special
    var subs = entity.fDescendents["Subordinate"];
    if (nSubs === 1) {
      var endPoint = { x: alignPoint.x, y: subs[0].fBox.fTop };
      this.AddLineAndAssociate(entity, alignPoint, endPoint, subs);
      return;
    }

    // the first vertical line from this to the horizontal crossbar
    var spacing = entity.GetMgrVSpacings();
    var topLineY = subs[0].fNodePoly.fEnvelope.fTop - spacing.lowerSpacing;
    endPoint = { x: alignPoint.x, y: topLineY };
    this.AddLineAndAssociate(entity, alignPoint, endPoint, subs);

    switch (entity.fSubBranchStyle) {
      case enumBranchStyle.twocolumn:
        var numBranches = 2;
        break;
      case enumBranchStyle.fourcolumn:
        numBranches = 4;
        break;
      case enumBranchStyle.sixcolumn:
        numBranches = 6;
        break;
      case enumBranchStyle.eightcolumn:
        numBranches = 8;
        break;
      case enumBranchStyle.twelvecolumn:
        numBranches = 12;
        break;
      case enumBranchStyle.sixteencolumn:
        numBranches = 16;
        break;
      case enumBranchStyle.twentycolumn:
        numBranches = 20;
        break;
      default:
        numBranches = 0;
        break;
    }

    numBranches = Math.min(numBranches, nSubs);

    var leftSubs = [];
    var rightSubs = [];

    var column = 0;
    var iJoint = 0;

    var groupSubsLeft = [];
    var groupSubsRight = [];

    while (column < numBranches) {
      leftSubs.length = 0;
      rightSubs.length = 0;

      for (i = column; i < nSubs; i += numBranches) {
        leftSubs.push(subs[i]);
        if (i + 1 < nSubs) {
          rightSubs.push(subs[i + 1]);
        }
      }

      var topLeftEnvelope = leftSubs[0].fNodePoly.fEnvelope;

      var columnAlignPoint = {
        x: entity.fMultiColumnJoints[iJoint++],
        y: topLeftEnvelope.fTop - spacing.lowerSpacing
      };

      if (columnAlignPoint.x < alignPoint.x) {
        groupSubsLeft.push({
          entities: leftSubs.slice(0).concat(rightSubs.slice(0)),
          node: columnAlignPoint
        });
      } else if (columnAlignPoint.x > alignPoint.x) {
        groupSubsRight.push({
          entities: leftSubs.slice(0).concat(rightSubs.slice(0)),
          node: columnAlignPoint
        });
      }
      this.AddLinesTwoColumn(entity, leftSubs, rightSubs, null, columnAlignPoint);
      column += 2;
    }

    groupSubsLeft.push({ entities: null, node: alignPoint });
    groupSubsRight.reverse();
    groupSubsRight.push({ entities: null, node: alignPoint });

    // now go over top horizontal line first for left, then for right ones
    var subsToAdd = [];

    for (var i = 0; i < groupSubsLeft.length - 1; i++) {
      subsToAdd = subsToAdd.concat(groupSubsLeft[i].entities);
      var point1 = { x: groupSubsLeft[i].node.x, y: groupSubsLeft[i].node.y };
      var point2 = { x: groupSubsLeft[i + 1].node.x, y: groupSubsLeft[i].node.y };
      this.AddLineAndAssociate(entity, point1, point2, subsToAdd);
    }

    subsToAdd.length = 0;
    for (i = 0; i < groupSubsRight.length - 1; i++) {
      subsToAdd = subsToAdd.concat(groupSubsRight[i].entities);
      point1 = { x: groupSubsRight[i + 1].node.x, y: groupSubsRight[i].node.y };
      point2 = { x: groupSubsRight[i].node.x, y: groupSubsRight[i].node.y };
      this.AddLineAndAssociate(entity, point1, point2, subsToAdd);
    }
  }

  // Creates one line and associates it with all entities in the entities array.
  // If any entity in the list is a co-manager container, the association is propagated to inside children
  // startPoint and endPoint are in global coordinate system
  AddLineAndAssociate(entity, startPoint, endPoint, entities) {
    if (!entity || !entity.fNode) {
      return;
    }

    var originPoint = {
      x: entity.fBox.fLeft + entity.fBox.fBorderThickness,
      y: entity.fBox.fTop + entity.fBox.fBorderThickness
    };

    if (this.fInvertedChart) {
      var yOffset = entity.fBox.fHeight - 2 * entity.fBox.fBorderThickness;
      var aLine = entity.fNode.AddALine(
        startPoint.x - originPoint.x,
        yOffset - (startPoint.y - originPoint.y),
        endPoint.x - originPoint.x,
        yOffset - (endPoint.y - originPoint.y)
      );
    } else {
      aLine = entity.fNode.AddALine(
        startPoint.x - originPoint.x,
        startPoint.y - originPoint.y,
        endPoint.x - originPoint.x,
        endPoint.y - originPoint.y
      );
    }

    if (Array.isArray(entities)) {
      var n = entities.length;
      for (var i = 0; i < n; i++) {
        var localEntity = entities[i];
        if (localEntity.NumChildren("InsideChild") > 0) {
          var insideChildren = localEntity.GetEntities("InsideChild");
          this.AddLineAndAssociate(entity, startPoint, endPoint, insideChildren);
        } else {
          var aLayout = localEntity.fNode.GetLayout();
          aLine.AssociateLayout(aLayout);
        }
      }
    } else {
      if (entities.NumChildren("InsideChild") > 0) {
        insideChildren = entities.GetEntities("InsideChild");
        this.AddLineAndAssociate(entity, startPoint, endPoint, insideChildren);
      } else {
        aLayout = entities.fNode.GetLayout();
        aLine.AssociateLayout(aLayout);
      }
    }
  }

  DetermineTwoColumnYs(lefts, rights) {
    var yLeft = Number.POSITIVE_INFINITY;
    var yRight = Number.POSITIVE_INFINITY;

    if (lefts.length === 0) {
      if (rights.length > 0) {
        yRight = rights[0].AnchorLeft().y;
      }
      return { left: yLeft, right: yRight };
    }

    if (rights.length === 0) {
      if (lefts.length > 0) {
        yLeft = lefts[0].AnchorRight().y;
      }
      return { left: yLeft, right: yRight };
    }

    if (lefts[0].fBox.fTop === rights[0].fBox.fTop) {
      yLeft = Math.min(lefts[0].AnchorRight().y, rights[0].AnchorLeft().y);
      yRight = Math.min(lefts[0].AnchorRight().y, rights[0].AnchorLeft().y);
    } else {
      yLeft = lefts[0].AnchorRight().y;
      yRight = rights[0].AnchorLeft().y;
    }

    return { left: yLeft, right: yRight };
  }
}
